import { ArrowRight, Store } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useT } from '@/components/visitone/visitone-provider'
import { ModuleShell } from '@/components/today/module-shell'
import { useTodayModule } from '@/hooks/use-today-module'
import type { TodayModuleProps } from '@/components/today/modules/types'

const PICKING_ROUTE = '/insights/picking'

export function PreOrdersModule({
  tenantId,
  venue,
  headingId,
  onOpenRoute,
  canOpenRoute,
  onDismiss,
  refusal,
}: TodayModuleProps) {
  const t = useT()
  const title = t('today.moduleTitles.pre-orders')
  const { data, error, isLoading, retry } = useTodayModule('pre-orders', tenantId, venue)

  // Hidden entirely when nothing is due (VIS-257 AC5).
  if (!isLoading && !error && (!data || data.groups.length === 0)) return null

  return (
    <ModuleShell
      title={title}
      headingId={headingId}
      isLoading={isLoading}
      error={error}
      onRetry={retry}
      onDismiss={onDismiss}
      refusal={refusal}
    >
      <p className="text-xs text-fg-muted">{t('today.preOrders.due')}</p>
      <ul className="flex flex-col divide-y divide-line">
        {data?.groups.map((group) => (
          <li key={group.outlet} className="flex items-center justify-between gap-3 py-2.5 first:pt-0">
            <span className="inline-flex items-center gap-2 text-sm text-fg">
              <Store aria-hidden="true" className="size-4 text-fg-muted" />
              {group.outlet}
            </span>
            <span className="text-sm font-medium text-fg-strong tabular-nums">
              {t('today.preOrders.count', { count: group.count })}
            </span>
          </li>
        ))}
      </ul>
      {canOpenRoute(PICKING_ROUTE) ? (
        <div>
          <Button variant="secondary" size="sm" onClick={() => onOpenRoute(PICKING_ROUTE)}>
            {t('today.preOrders.open')}
            <ArrowRight />
          </Button>
        </div>
      ) : null}
    </ModuleShell>
  )
}
